/*
 * bgn-eur-cart.js  —  BGN injector for app/JS-rendered prices.
 *
 * The product MAIN price is Liquid (price.liquid) so it is instant & flicker-free.
 * This scoped scanner handles prices the theme renders with JS and Liquid cannot
 * reach: the Swatch King variant radios/cards, on-page collection sections, and
 * the cart. It wraps the EUR amount in .dp-eur and appends .dp-bgn, each tagged
 * with a location class (swatch / collection) so they can be styled separately.
 *
 * Safe: skips anything already dual (no double-convert), strict EUR regex, scoped
 * observers, debounced. Swatch injection is gated by a setting and the single-
 * selection guard (sk-variant-stabilizer.js) protects the radios.
 */
(function () {
  'use strict';
  var CFG = window.__BGN_CFG__ || {};
  if (!CFG.enabled) return;
  var rate = parseFloat(CFG.rate) || 1.95583;
  var page = CFG.page || '';
  var on = CFG.on || {};
  var swatchOn = !!CFG.swatch;

  function pageOn(p) {
    if (p === 'collection' || p === 'list-collections') return !!on.collection;
    if (p === 'index') return !!on.home;
    if (p === 'cart') return !!on.cart;
    if (p === 'product') return !!on.product;
    return !!on.other;
  }
  var doCart = !!on.cart;
  var doMain = pageOn(page);
  if (!doCart && !doMain) return;

  var CART_SEL = 'cart-drawer, cart-notification, #main-cart-items, #main-cart-footer, .cart__footer, .drawer__footer, .totals';
  var SWATCH_SEL = '.swatch-view-item, .swatch-single, .swatches, .swatch-custom-image';
  var EXCLUDE = '[data-no-bgn]' + (CFG.exclude ? ', ' + CFG.exclude : '');
  var EUR_RE = /€\s?\d{1,3}(?:[.\s]\d{3})*,\d{2}/;

  function fmt(lev) { var s = lev.toFixed(2).split('.'); return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + s[1] + ' лв'; }
  function parseEUR(t) { var m = t.match(/(\d{1,3}(?:[.\s]\d{3})*,\d{2})/); if (!m) return null; var v = parseFloat(m[1].replace(/[.\s]/g, '').replace(',', '.')); return isNaN(v) ? null : v; }
  function locOf(el) { return (el.closest && el.closest(SWATCH_SEL)) ? 'swatch' : 'collection'; }

  function convert(root) {
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var v = n.nodeValue;
        if (!v || !EUR_RE.test(v)) return NodeFilter.FILTER_REJECT;
        if ((v.match(/€/g) || []).length > 1) return NodeFilter.FILTER_REJECT; // one price per node only
        var p = n.parentNode;
        if (!p || !p.closest) return NodeFilter.FILTER_REJECT;
        if (p.closest('.dp-bgn, .dp-eur')) return NodeFilter.FILTER_REJECT;
        if (EXCLUDE && p.closest(EXCLUDE)) return NodeFilter.FILTER_REJECT;
        if (!swatchOn && p.closest(SWATCH_SEL)) return NodeFilter.FILTER_REJECT;
        if (/лв/.test(p.textContent)) return NodeFilter.FILTER_REJECT; // already dual
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var arr = [], n;
    while ((n = w.nextNode())) arr.push(n);
    arr.forEach(function (node) {
      var e = parseEUR(node.nodeValue);
      if (e == null) return;
      var loc = locOf(node.parentNode);
      var eur = document.createElement('span'); eur.className = 'dp-eur dp-eur--' + loc; eur.textContent = node.nodeValue;
      var bgn = document.createElement('span'); bgn.className = 'dp-bgn dp-bgn--' + loc; bgn.textContent = ' (' + fmt(e * rate) + ')';
      var frag = document.createDocumentFragment(); frag.appendChild(eur); frag.appendChild(bgn);
      node.parentNode.replaceChild(frag, node);
    });
  }

  // Badge & out-of-stock engine moved to assets/dp-overlay.js (loaded by the section).

  function roots() {
    var r = [];
    if (doCart) [].forEach.call(document.querySelectorAll(CART_SEL), function (x) { r.push(x); });
    if (doMain) { var m = document.querySelector('#MainContent') || document.querySelector('main') || document.body; if (m) r.push(m); }
    return r;
  }
  function run() { roots().forEach(convert); }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(run, 140); }
  function init() {
    run();
    roots().forEach(function (r) { try { new MutationObserver(schedule).observe(r, { childList: true, subtree: true, characterData: true }); } catch (e) {} });
    document.addEventListener('cart:refresh', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
